import { createSvgIcon } from '@mui/material';
import { styled } from '@mui/material';

const ImportIcon = createSvgIcon(
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M13.6997 7.61108C16.6997 7.86942 17.9247 9.41108 17.9247 12.7861V12.8944C17.9247 16.6194 16.4331 18.1111 12.7081 18.1111H7.28307C3.55807 18.1111 2.06641 16.6194 2.06641 12.8944V12.7861C2.06641 9.43608 3.27474 7.89442 6.22474 7.61942'
			stroke='currentColor'
			stroke-width='1.5'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M10 1.86108V12.5944'
			stroke='currentColor'
			stroke-width='1.5'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M12.7913 10.7361L9.99967 13.5278L7.20801 10.7361'
			stroke='currentColor'
			stroke-width='1.5'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
	</svg>,
	'Import'
);

export const Import = styled(ImportIcon)(() => ({
	fill: '#fff0'
}));

export default Import;
